import { useSelector } from 'react-redux'

const Restricted = ({
  roles = null,
  excludeRoles = null,
  children,
  fallback = null,
}) => {
  const currentUser = useSelector((state) => state.Auth.user)
  if (roles && excludeRoles) {
    return fallback
  }
  if (roles) {
    const shouldRender = roles.includes(currentUser.role)
    return shouldRender ? children : fallback
  }
  if (excludeRoles) {
    const shouldRender = !excludeRoles.includes(currentUser.role)
    return shouldRender ? children : fallback
  }
}

export default Restricted
